/**
 * 路由扩展
 * @param router - 路由
 * @param routes - 路由实例集
 * */
export default function routerExtend(router, routes) {

    // 遍历设置导航方法
    for (const route of routes) {

        // 导航方法
        let navigateTo = function (params = {}) {

            router.push({
                name: route.name,
                params
            });
        }

        // 赋值导航方法
        router[`push${route.name}`] = navigateTo;

        // 重定向方法
        let redirectTo = function (params = {}) {

            router.replace({
                name: route.name,
                params
            });
        }
        // 赋值重定向方法
        router[`replace${route.name}`] = redirectTo;

        // 递归
        if (route.children && route.children.length > 0)
            routerExtend(router, route.children);
    }

}